<template>
    <div
        class="relative flex h-[500px] w-[400px] flex-col rounded-lg p-10"
        :class="{ 'justify-end': config.alignBottom, border: config.withPortalContainer }"
    >
        <component :is="config.withPortalContainer ? PortalContainer : NoopWrapper">
            <InputSelect
                :options="config.options"
                :value="playgroundSelectedValues"
                :label="config.label"
                :placeholder="config.placeholder"
                :unique-key="config.uniqueKey"
                :required="config.required"
                :disabled="config.disabled"
                :error-message="config.errorMessage"
                :multiselect="config.multiselect"
                @update="setPlaygroundSelectedValues"
            />
            <br />

            <br />
            <br />
            <br />
            <InputSelectDeprecated
                :options="config.options"
                :value="playgroundSelectedValues"
                :label="config.label"
                :placeholder="config.placeholder"
                :unique-key="config.uniqueKey"
                :required="config.required"
                :disabled="config.disabled"
                :multiselect="config.multiselect"
                :error-message="config.errorMessage"
                @update="setPlaygroundSelectedValues"
            />
        </component>

        <!-- <div>
            {{ playgroundSelectedValues }}
        </div> -->
    </div>
</template>

<script setup lang="ts">
import type { Option } from '@/stores/store-interfaces';
import { defineComponent } from 'vue';
import PortalContainer from '@/components/support/portal-container.vue';
import InputSelectDeprecated from '@/components/support/input-select-deprecated.vue';
import InputSelect from '@/components/support/input-select.vue';
import type { PlayGroundInputSelectConfig } from './playground-input-select-group.vue';

const { config } = defineProps<{
    config: PlayGroundInputSelectConfig;
}>();

const playgroundSelectedValues = config.selected;

function setPlaygroundSelectedValues(value: Option[]) {
    playgroundSelectedValues.value = value;
}

// No-op wrapper to avoid duplicating the inner component
const NoopWrapper = defineComponent({
    name: 'NoopWrapper',
    setup(_, { slots }) {
        return () => slots.default?.();
    },
});
</script>

<style scoped></style>
